"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
function default_1({ noticeType, noticeLine, }) {
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: maxWidth768 ? 'surface-white' : 'surface-table-row', css: {
            display: 'flex',
            alignItems: 'center',
            columnGap: '8px',
            width: '100%',
            height: '48px',
            padding: '0 16px',
            borderRadius: maxWidth768 ? 0 : '8px',
            borderBottom: maxWidth768 ? '1px solid var(--gray-5)' : 0,
            marginBottom: maxWidth768 ? '10px' : 0,
        } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1 surface-primary-main", css: {
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    height: '24px',
                    padding: '0 8px',
                    borderRadius: '6px',
                    color: 'white',
                } }, { children: noticeType })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: noticeLine }))] })));
}
exports.default = default_1;
